import UnitHelper from "../../../../helpers/UnitHelper";

class AnthropometricsHelper {
  static metadata = [
    {
      label: "Height",
      value: "height",
      name: "Height",
      field: "height",
      unitOfMeasure: UnitHelper.units.Metre,
      displayMetadata: {
        metric: {
          unit: UnitHelper.units.Centimetre,
          decimals: null,
        },
        imperial: {
          unit: "FeetInches",
          decimals: null,
        },
      },
      isDefault: true,
      sortType: /** @type {0 | 1} */ (0),
      isPbEnabled: false,
    },
    {
      label: "Weight",
      value: "weight",
      name: "Weight",
      field: "weight",
      unitOfMeasure: "Kilogram",
      displayMetadata: {
        metric: {
          unit: UnitHelper.units.Kilogram,
          decimals: null,
        },
        imperial: {
          unit: UnitHelper.units.Pound,
          decimals: null,
        },
      },
      isDefault: true,
      sortType: /** @type {0 | 1} */ (0),
      isPbEnabled: false,
    },
  ];
}
export default AnthropometricsHelper;
